//全局注册组件
// 更换员工
import scan from '@/components/scan.vue';
// 提交状态
import statustip from '@/components/statustip.vue';

//数组存放接收的组件名
const components = [
  { name: "scan", con: scan },
  { name: "statusTip", con: statustip }
]
//循环注册组件
const install = function (Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component.con);
  });
};

export default {
  install
};
